import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import ChangeProfilePage, { getDefaultPageUI } from "components/pages/ChangeProfilePage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import Classes from "model";

/**
 * @function CaptureChangeProfileDD
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @description This component is used to capture ZLE in the 
 * context of MABI23 in the "Small Business" group.
 */
export default function CaptureChangeProfileDD(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = useModel();
    const { options } = branding;
    const howIsZellePresented = options.present_zelle_abi22 ? options.present_zelle_abi22.toLowerCase() : undefined;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "currentProfileSelectIsActive" ], true)
    .update([ "showHeader" ], false)
    .submit();

    if(howIsZellePresented === "checkfree") {
        const message = `This capture is not shown when ABI22 branding option "How is Zelle Presented?" is set to "Checkfree".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return <ChangeProfilePage ui={ ui }/>;
}